
import { defineComponent, onMounted } from "vue";
import {getPGIModelData, claimPGI} from "@/api/pgi"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import {isPGIQualified} from "@/api/dashboard"
import PGITravelTickets from "./PGITravelTickets.vue";

import DashboardTabNavigator from "@/components/dashboard/DashboardTabNavigator.vue";

export default defineComponent({
  name: "widgets-feeds",
  components: {
    DashboardTabNavigator,
    PGITravelTickets
  },
  data(){
    return {
      pgiproducts : [],
      travel_points : 0,
      history:[],
      isLoading:true,
      isPGIQualified:false,
    }
  },
  methods:{
    async checkIfPGIQualified(){
      const response = await isPGIQualified();
      console.log(response.data);
      this.isPGIQualified = response.data.isPGIQualified;
    },
    async getPGIModelData(){
      this.isLoading = true;
      const response = await getPGIModelData(0);
      this.pgiproducts = response.data.pgiproducts;
      this.travel_points = response.data.travel_points;
      this.history = response.data.history;
      this.isLoading = false;
    },
    async claimPGI(pgicode){
      this.isLoading = true;
      let param = {"pgicode" : pgicode}
      const response = await claimPGI(param);
      if(response != null){
          this.isLoading = false;
          
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            }); 
            window.location.reload();
            return; 
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
    }
  },
  mounted(){
    this.getPGIModelData();
    this.checkIfPGIQualified();
  }
});
